import React, { createContext, useContext } from 'react'

import styles from './FormControl.module.css'

const FormContext = createContext({
  isValid: true
})

export const useFormControl = () => useContext(FormContext)

const FormControl = (props) => {
  const { isInvalid, ...rest } = props

  const contextValues = {
    isInvalid
  }

  return (
    <FormContext.Provider value={contextValues}>
      <div className={styles.ControlGroup} {...rest} role='group' />
    </FormContext.Provider>
  )
}

export default FormControl
